import type { TutorKanbanStore } from './interfaces'
import type { TutorKanbanStage } from '@brighterly/lib-core-types/tutor-kanban/enums'

export const getters = {
  isLoading: (state: TutorKanbanStore): TutorKanbanStore['loading'] => state.loading,
  getTutors: (state: TutorKanbanStore): TutorKanbanStore['tutors'] => state.tutors,
  getAgents: (state: TutorKanbanStore): TutorKanbanStore['agents'] => state.agents,
  getTutor: (state: TutorKanbanStore): TutorKanbanStore['tutor'] => state.tutor,
  getStage: (state: TutorKanbanStore): TutorKanbanStage | null => state.tutor?.stage || null,
  getSavedStage: (state: TutorKanbanStore): TutorKanbanStore['savedStage'] => state.savedStage,
  getSavedStageReasons: (state: TutorKanbanStore): string[] => state.savedStageDetails.reasons,
  getSavedStageCategories: (state: TutorKanbanStore): string[] => state.savedStageDetails.categories,
  getSavedExitDate: (state: TutorKanbanStore): TutorKanbanStore['savedExitDate'] => state.savedExitDate,
  getExitDate: (state: TutorKanbanStore): string | null => state.tutor?.exit_date ?? null,
  isFinalDayConfirmOpen: (state: TutorKanbanStore): TutorKanbanStore['finalDayConfirmOpen'] => state.finalDayConfirmOpen,
  getPendingStageReasons: (state: TutorKanbanStore): TutorKanbanStore['pendingStageReasons'] => state.pendingStageReasons,
  getReasonConfirmSource: (state: TutorKanbanStore): TutorKanbanStore['reasonConfirmSource'] => state.reasonConfirmSource,
  getReasonResetKey: (state: TutorKanbanStore): TutorKanbanStore['reasonResetKey'] => state.reasonResetKey,
  getTimezone: (state: TutorKanbanStore): string => state.tutor?.timezone ?? '',
  getLogs: (state: TutorKanbanStore): TutorKanbanStore['logs'] => state.logs,
  getLogsPagination: (state: TutorKanbanStore): TutorKanbanStore['logsPagination'] => state.logsPagination,
  getTimeOffs: (state: TutorKanbanStore): TutorKanbanStore['timeOffs'] => state.timeOffs,
}
